import React from "react";
import classNames from "classnames";

const FieldDisplay = ({ label, value, children, className }) => {
  return (
    <div className={classNames('row mb-1 align-items-start', className)}>
      <div className="col-md-3 p-y-8">
        <label className="form-label mb-0">{label}:</label>
      </div>
      <div className="col-md-9 p-y-8 d-flex align-items-center">
        {value && <p className="mb-0">{value}</p>}
        {children}
      </div>
    </div>
  );
};

export default FieldDisplay;
